import { isAgencyGroup } from '@/sections/settings/AgenciesSettings/agencies-utils'
import type { GroupWithUserData } from './types'

export type AgencyMembership = { gid: string; name: string }
export type AgencyMembershipsByUser = Record<string, AgencyMembership[]>

function collectAgencyMembershipsMap(
  groups: GroupWithUserData[],
  acc: Map<string, Map<string, AgencyMembership>> = new Map()
): Map<string, Map<string, AgencyMembership>> {
  for (const group of groups) {
    const gid = group.gid
    const label = group.name?.trim()

    if (gid && label && isAgencyGroup(group)) {
      for (const user of group.membersDetails ?? []) {
        const uid = user.uid
        if (!uid) continue

        let byGid = acc.get(uid)
        if (!byGid) {
          byGid = new Map()
          acc.set(uid, byGid)
        }
        byGid.set(gid, { gid, name: label })
      }
    }

    if (group.children?.length) {
      collectAgencyMembershipsMap(group.children, acc)
    }
  }

  return acc
}

export function collectAgencyMembershipsByUserRecord(
  groups: GroupWithUserData[]
): AgencyMembershipsByUser {
  const map = collectAgencyMembershipsMap(groups)
  const out: AgencyMembershipsByUser = {}

  map.forEach((byGid, uid) => {
    out[uid] = Array.from(byGid.values()).sort((a, b) =>
      a.name.localeCompare(b.name, 'fr')
    )
  })

  return out
}

export function agencyMembershipsToNames(
  memberships: AgencyMembership[] | undefined
): string[] {
  return (memberships ?? []).map((m) => m.name)
}
